// Widget dimension constants
export const WIDGET_PANEL_WIDTH = 380
export const WIDGET_PANEL_HEIGHT = 780
export const WIDGET_BUBBLE_SIZE = 60
export const WIDGET_MARGIN = 20
export const WIDGET_HEADER_HEIGHT = 52
export const WIDGET_BORDER_RADIUS = 16

// Breakpoint below which the panel goes near-full-screen
export const WIDGET_MOBILE_BREAKPOINT = 768

// Shared height breakpoints for responsive widget compaction.
export const WIDGET_HEIGHT_BREAKPOINTS = {
  relaxed: 875,
  compact: 750,
  tight: 650,
} as const

export const WIDGET_HEIGHT_MEDIA_QUERIES = {
  relaxed: `@media (max-height: ${WIDGET_HEIGHT_BREAKPOINTS.relaxed}px)`,
  compact: `@media (max-height: ${WIDGET_HEIGHT_BREAKPOINTS.compact}px)`,
  tight: `@media (max-height: ${WIDGET_HEIGHT_BREAKPOINTS.tight}px)`,
} as const

// Slideout sidebar width (slightly wider than the overlay panel)
export const WIDGET_SLIDEOUT_WIDTH = 420
